const getSessionAuthToken = () => {
    return window.localStorage.getItem('at');
};

export default getSessionAuthToken;
